import DistributionManifestRoutes from './distribution-manifest';
import PointOfSaleRoutes from './point-of-sale';
import SalesOrderRoutes from './sales';
import SampleRequestRoutes from './sample-request';

export default [
    ...DistributionManifestRoutes,
    ...PointOfSaleRoutes,
    ...SalesOrderRoutes,
    ...SampleRequestRoutes,
];